import axios from "axios";
import { userManager } from "../auth/authConfig";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

apiClient.interceptors.request.use(async (config) => {
  const user = await userManager.getUser();
  if (user?.access_token && !user.expired) {
    config.headers.Authorization = `Bearer ${user.access_token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response?.status === 401 && !error.config._retried) {
      error.config._retried = true;
      // Si no hay sesión iniciada (p. ej. CombustibleMapaMovil sin usuario logeado),
      // no forzamos un redirect a login: simplemente propagamos el error.
      const user = await userManager.getUser();
      if (!user) {
        return Promise.reject(error);
      }
      try {
        const renewedUser = await userManager.signinSilent();
        if (renewedUser?.access_token) {
          error.config.headers.Authorization = `Bearer ${renewedUser.access_token}`;
          return apiClient(error.config);
        }
      } catch (e) {
        await userManager.signinRedirect();
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;